// extracted by mini-css-extract-plugin
export default {"list":"MoreMenuButton__list--3xAYA","itemWrapper":"MoreMenuButton__itemWrapper--2aVGJ","item":"MoreMenuButton__item--3c9uC","icon":"MoreMenuButton__icon--sV2r2"};